<p>packaging-part-tree works!</p>
